<itl-detail-item>
  <itl-detail-item-icon>
    <itl-alberta-icon name="alberta-article"></itl-alberta-icon>
  </itl-detail-item-icon>
  <div class="articleData">
    <div>
      <div class="articleName bold">{{ serviceLine?.service?.name }}</div>
      <div class="bold dosage">Anzahl: {{ serviceLine?.quantity }}, {{ getDosageDisplayText(serviceLine.dosage) }}</div>
    </div>
    <div class="labels">
      <itl-card class="showMoreButton" (click)="toggleShowMore()"
        ><itl-alberta-icon [name]="serviceExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"></itl-alberta-icon
      ></itl-card>
    </div>
  </div>
  <div *ngIf="serviceExpanded" class="cardContainer">
    <itl-card [header]="'serviceEntity.description' | translate">
      {{ serviceLine?.service.description ? serviceLine.service.description : 'k.A.' }}
    </itl-card>
    <itl-card [header]="'serviceEntity.additionalDescription' | translate">
      {{ serviceLine?.service.additionalDescription ? serviceLine.service.additionalDescription : 'k.A.' }}
    </itl-card>
    <itl-card [header]="'serviceEntity.duration' | translate">
      {{
        serviceLine?.service?.taskOptions?.default?.duration
          ? serviceLine.service.taskOptions.default.duration + ' Minuten'
          : 'k.A.'
      }}
    </itl-card>
    <itl-card [header]="'serviceEntity.customerNumber' | translate">
      {{
        serviceLine?.service.taskOptions?.default?.customerNumber
          ? serviceLine.service.taskOptions.default.customerNumber
          : 'k.A.'
      }}
    </itl-card>
    <itl-card [header]="'serviceEntity.location' | translate">
      {{
        serviceLine?.service.taskOptions?.default?.location
          ? (serviceLine.service.taskOptions.default.location | serviceLocationPipe)
          : 'k.A.'
      }}
    </itl-card>
  </div>
</itl-detail-item>
